import type { Tone } from './Badge';

export interface StatusMarkProps {
  /**
   * ok = filled blue ✓ · partial = half-filled · fail = red ✕ · neutral = outlined ·
   * now = the tilted coral tile · live = filled blue with a white dot.
   */
  tone?: Tone;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * The square that carries a status's shape (Tangram): status is never told by colour alone, so
 * each tone has its own shape. Decorative: the word next to it is what assistive tech reads.
 */
export function StatusMark({ tone = 'neutral', size = 'md' }: StatusMarkProps) {
  const classes = ['fs-mark', `fs-mark--${tone}`];
  if (size !== 'md') classes.push(`fs-mark--${size}`);
  return <span className={classes.join(' ')} aria-hidden="true" />;
}
